import {dispatchTrackEvent} from "./_tracking";
import {scrollSmoothElement} from "./_smoothScroll";

export default function initAnchors() {
  trackAnchor();
  anchorScroll();
}

function anchorScroll() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      if(event.target.hash) scrollSmoothElement(document.querySelector(event.target.hash));
    });
  });
}

function trackAnchor() {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', (event) => {
      dispatchTrackEvent({
        'eventCategory': 'anchor link',
        'eventAction': 'click',
        'eventLabel': event.target.innerText,
        'eventValue': 1,
        'nonInteraction': false,
      }, anchor);
    });
  });
}
